import { styled } from '@teko/ui';
import React from 'react';
import { VariantItem } from './VariantItem.es.js';

const Wrapper = styled.div``;
const VariantWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  overflow-y: hidden;
  overflow-x: auto;
`;
const SelectedVariant = styled.div`
  font-family: Roboto, sans-serif;
  font-weight: 500;
  font-size: 10px;
  line-height: 16px;
  color: #82869e;
  margin-bottom: 4px;
  text-transform: uppercase;
`;
const ProductVariantsMobile = ({
  configuration,
  onSelectVariant,
  index,
  className
}) => {
  const selectedOption = configuration.options.find((variant) => {
    return variant.selected;
  });
  return /* @__PURE__ */ React.createElement(Wrapper, {
    className
  }, /* @__PURE__ */ React.createElement(SelectedVariant, null, configuration.name, selectedOption ? `: ${selectedOption.value}` : ``), /* @__PURE__ */ React.createElement(VariantWrapper, null, configuration.options.map((variant) => /* @__PURE__ */ React.createElement(VariantItem, {
    key: variant.optionId,
    option: variant,
    onSelectVariant,
    index
  }))));
};

export { ProductVariantsMobile };
